export default __webpack_public_path__ + "static/teammate5-3200790716dbb8da9fd67d14a1d2e40c.png";